<template>
  <InvestigationWrapper />
</template>

<script>
import InvestigationWrapper from '@/components/investigation/InvestigationWrapper.vue'

export default {
  name: 'InvestigationPerson',
  components: {
    InvestigationWrapper
  }
}
</script>
